/* 0.47.74 - How a dropdown's row is compared with the field it is
 * filtered by ("Filter options by another field").
 *
 * e.filter_op:
 *   'equals' (default, unset)  the row's column equals the field's value
 *                              (any of them, for a multi-select field),
 *                              as before
 *   'not_equals'               differs from every value of the field
 *   'lt' | 'lte' | 'gt' | 'gte'  the row's column is less than / at most /
 *                              more than / at least the field's value
 *                              (any of them), read as numbers
 *
 * A row whose column is empty, or not a number for a number comparison,
 * is left out. */

export const CASCADE_OPS = [
  { value: 'equals', label: 'equals' },
  { value: 'not_equals', label: 'does not equal' },
  { value: 'lt', label: 'is less than' },
  { value: 'lte', label: 'is at most' },
  { value: 'gt', label: 'is more than' },
  { value: 'gte', label: 'is at least' },
];

const NUM_OPS = new Set(['lt', 'lte', 'gt', 'gte']);

export function cascadeOp(e) {
  const op = e && e.filter_op;
  return CASCADE_OPS.some(o => o.value === op) ? op : 'equals';
}

export function isNumberCascade(e) {
  return NUM_OPS.has(cascadeOp(e));
}

const toNum = (x) => {
  if (x === undefined || x === null || x === '' || typeof x === 'boolean') return null;
  if (typeof x === 'number') return Number.isFinite(x) ? x : null;
  const s = String(x).trim().replace(/[\s  ,]/g, '');
  if (s === '') return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
};

/* parentVal: the field's value (a value, or an array for a multi-select).
 * The caller handles an empty parent (no options). */
export function cascadeMatches(rowVal, parentVal, op = 'equals') {
  const parents = (Array.isArray(parentVal) ? parentVal : [parentVal])
    .filter(v => v !== '' && v != null);
  if (rowVal === undefined || rowVal === null || rowVal === '') return false;
  if (op === 'equals') return parents.some(p => String(p) === String(rowVal));
  if (op === 'not_equals') return parents.every(p => String(p) !== String(rowVal));
  const r = toNum(rowVal);
  if (r === null) return false;
  return parents.some(p => {
    const n = toNum(p);
    if (n === null) return false;
    if (op === 'lt') return r < n;
    if (op === 'lte') return r <= n;
    if (op === 'gt') return r > n;
    return r >= n;
  });
}
